var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.inputComponent,_vm._b({tag:"component",staticClass:"j-input",on:{"change":function($event){return _vm.$emit('change')}}},'component',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }